import * as React from 'react';

import * as tracking from './tracking';
import * as styles from './ClearFiltersButton.css';

export interface IClearFiltersButtonProps {
  onClick(): void;
}

export class ClearFiltersButton extends React.Component<IClearFiltersButtonProps> {
  public render() {
    return (
      <button className={styles['button']} onClick={this.handleButtonClick}>
        Очистить фильтры
      </button>
    );
  }

  private handleButtonClick = () => {
    this.props.onClick();
    tracking.trackButtonClick();
  };
}
